import { useRef, useCallback, useState } from 'react';
import { DepthOfField } from '@react-three/postprocessing';
import { Vector3 } from 'three';
import { parallax } from '@immutabl3/alchemy/three';
import animation from './DoF.animation.json';

export default function DoF() {
  const ref = useRef();
  const [v3] = useState(() => new Vector3());

  const onAnimation = useCallback((_, anim) => {
    const { animations } = anim;
    const dof = ref.current;
    if (!dof) return;
    
    for (const { property, currentValue } of animations) {
      dof.target[property] = currentValue;
    }
  }, []);

  return (
    <>
      <parallax.group
        beaker="chapter3"
        animation={ animation }
        onAnimation={ onAnimation }
      />
      <DepthOfField
        ref={ ref }
        target={ v3 }
        // focusDistance={ 0 } // where to focus
        focalLength={ 0.02 } // focal length
        bokehScale={ 10 } // bokeh size
      />
    </>
  );
};